import React from 'react';
import { Checkbox, Tooltip } from 'antd';
import { useTemplateListingStore } from '../store';

export default function ShowOnlyActiveCheckBox() {
  const { onlyActive, setOnlyActive } = useTemplateListingStore();
  return (
    <Checkbox
      checked={onlyActive}
      onChange={() => {
        setOnlyActive(!onlyActive);
      }}
    >
      <Tooltip
        placement="topRight"
        title="When checked, displays only templates used within the last 2 months"
      >
        Show Only Active?
      </Tooltip>
    </Checkbox>
  );
}
